import React, { useState } from 'react';
import './ResultsCard.css';

import './ProgressBar/ProgressBar'
import ProgressBar from './ProgressBar/ProgressBar';
import arrow from '../../../assets/icons/ArrowResulsCard.svg'
import { parse } from '@fortawesome/fontawesome-svg-core';


/*
Props:
    total: Total of people who voted here
    name: The name of the voting card, is usually "Da", "Nu", "Abtinere"
    votes: The amount of people who voted on this card
    children: The people who voted(syntax: <ResultsCard>here</ResultsCard>)
*/


    // this divides by 0 if there are no votes. Too bad!

const ResultsCard = ({ total,name,voteCount,children,type,countingRule, otherVotes, isAbstain }) => {

    let value = 0
    let voteWon = false


    if(total !== 0) value = (Math.trunc(voteCount/total*100*100))/100;
    if(countingRule === "most votes") voteWon = voteCount > otherVotes.reduce((a,b) => a > b ? a : b, 0)
    if(countingRule === "1/2 majority") voteWon = voteCount > total/ 2.0
    if(countingRule === "2/3 majority") voteWon = voteCount > total * 2.0 / 3.0

    const [isExpanded, setIsExpanded] = useState(false);

    const handleExpandClick = () => {
        setIsExpanded(!isExpanded);
    };
    //text init
    const voteCountText = "voturi"
    const seeMoreText = "Vezi mai mult"
    const seeLessText = "Vezi mai putini"
    return (
        <div className="resultsCardbBg"  style={voteWon && !isAbstain ? {border:"solid 3px var(--green)"}: {}}>
            <div className="resultsCardTitleProc">
                <div className="resultTextBlack">{name}</div>
                <div className="resultTextBlack">{value}%</div>
            </div>
            <ProgressBar value={value} />
            <div className="resultVoteNumber" data-testid="resultsVoteNumber" >
                {voteCount} {voteCountText}
            </div>

            {isExpanded?children:""}
            {
                (type == 'public' && voteCount > 0) ? (
                    <div className="resultsSeeMore" onClick={handleExpandClick}>
                        <img src={arrow} className={isExpanded ? "resultsReverseArrow" : ""} alt='' />
                        <div className="resultTextBlack" style={{ cursor: "pointer" }}>{isExpanded ? seeLessText : seeMoreText}</div>
                    </div>
                ) : (<></>)
            }
        </div>
    );
};

export default ResultsCard;